/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base breakpoints for the Soft UI Dashboard PRO React.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire Soft UI Dashboard PRO React using thie file.
 */

const vertical_breakpoints = {
    values: {
      vxs: 0,
      vsm: 667,
      vmd: 768,
      vlg: 1024,
      vxl: 1080,
      vxxl: 1200,
      vx3l: 1320,
    },
  };
  
  export default vertical_breakpoints;